import { create } from 'zustand';

export interface AppState {
  // 语言设置
  language: string;
  setLanguage: (lang: string) => void;

  // 主题设置
  theme: 'dark' | 'light';
  setTheme: (theme: 'dark' | 'light') => void;

  // 全局计数器（演示用）
  counter: number;
  increment: () => void;
  decrement: () => void;
  reset: () => void;

  // 渠道和产品线信息
  vChannelId: string;
  prodLine: string;
  platform: string;
  setVChannelId: (id: string) => void;
  setProdLine: (line: string) => void;
  setPlatform: (platform: string) => void;

  // 事件订阅系统
  subscribers: Map<string, Set<(data: any) => void>>;
  subscribe: (event: string, callback: (data: any) => void) => () => void;
  emit: (event: string, data?: any) => void;
}

export const useAppStore = create<AppState>((set, get) => ({
  // 初始状态
  language: localStorage.getItem('i18nextLng') || 'en',
  theme: 'dark',
  counter: 0,
  vChannelId: localStorage.getItem('vChannelId') || '',
  prodLine: localStorage.getItem('prodLine') || '',
  platform: localStorage.getItem('platform') || '',
  subscribers: new Map(),

  // 语言切换
  setLanguage: (lang: string) => {
    set({ language: lang });
    get().emit('language:change', { language: lang });
  },

  // 主题切换
  setTheme: (theme: 'dark' | 'light') => {
    set({ theme });
    get().emit('theme:change', { theme });
  },

  // 计数器操作
  increment: () =>
    set((state) => ({
      counter: state.counter + 1,
    })),

  decrement: () =>
    set((state) => ({
      counter: state.counter - 1,
    })),

  reset: () => set({ counter: 0 }),

  // 渠道和产品线设置
  setVChannelId: (id: string) => {
    set({ vChannelId: id });
    localStorage.setItem('vChannelId', id);
  },

  setProdLine: (line: string) => {
    set({ prodLine: line });
    localStorage.setItem('prodLine', line);
  },

  setPlatform: (platform: string) => {
    set({ platform });
    localStorage.setItem('platform', platform);
  },

  // 事件订阅
  subscribe: (event: string, callback: (data: any) => void) => {
    const { subscribers } = get();

    if (!subscribers.has(event)) {
      subscribers.set(event, new Set());
    }

    subscribers.get(event)!.add(callback);

    // 返回取消订阅函数
    return () => {
      const subs = get().subscribers.get(event);
      if (subs) {
        subs.delete(callback);
      }
    };
  },

  // 触发事件
  emit: (event: string, data?: any) => {
    const { subscribers } = get();
    const subs = subscribers.get(event);

    if (subs) {
      subs.forEach((callback) => callback(data));
    }
  },
}));
